import { selectBalancingOutskirtUnlockLevel } from "../balancingSelectors/selectBalancingOutskirts";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { warn } from "../utils/logging/logging";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectHarborInfo = function (state) {
    warn("Harbor not implemented!");
};
export var selectIsQualifiedForHarbor = function (state) {
    var level = selectPlayerLevel(state);
    return level >= selectBalancingOutskirtUnlockLevel(IdOutskirtBuildings.Harbor);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectHarborInfo.ts
// module id = 2155
// module chunks = 3